<template>
  <div class="subsector oilnaturalgas">
    <div class="parent-sector">
      <p>Energy</p>
    </div>
    <div class="content">
      <div class="row">
        <div class="col-md-6">
          <h1>Oil and Natural Gas</h1>
          <div class="row">
            <div class="col-sm">
              <p>
                CH₄ is the principal component of natural gas and is emitted
                during natural gas production, processing, transmission, and
                distribution. Oil production and processing upstream of oil
                refineries can also emit CH₄ in significant quantities as
                natural gas is often found in conjunction with petroleum
                deposits. In both systems, CH₄ is a fugitive emission from
                leaking equipment, system upsets, deliberate flaring and venting
                at production fields, processing facilities, natural gas
                transmission lines and compressor stations, natural gas storage
                facilities, and natural gas distribution lines.
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <p class="center">
            <button
              @click="
                switchComponent('ChartOilNaturalGas1');
                activate(1);
              "
              :class="{ active: active_el == 1 }"
            >Projected Emissions</button>
            <button
              @click="
                switchComponent('ChartOilNaturalGas2');
                activate(2);
              "
              :class="{ active: active_el == 2 }"
            >Reduction Potential</button>
          </p>

          <div class="container">
            <component v-bind:is="currentComp"></component>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ChartOilNaturalGas1 from "@/components/energy/ChartOilNaturalGas1";
import ChartOilNaturalGas2 from "@/components/energy/ChartOilNaturalGas2";

export default {
  components: {
    ChartOilNaturalGas1,
    ChartOilNaturalGas2
  },
  data() {
    return {
      currentComp: "ChartOilNaturalGas1",
      active_el: 1
    };
  },
  methods: {
    switchComponent(comp) {
      //alert("test comp: " + comp);
      return (this.currentComp = comp);
    },
    activate: function(el) {
      this.active_el = el;
    }
  }
};
</script>

<style scoped>
h1 {
  font-weight: normal;
  font-size: 1.6rem;
  margin-bottom: 1rem;
}
.subsector {
  background: url("../../assets/bg-blue-gold-nav.png") 0 -85px repeat-x;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
  border-radius: 5px;
}

.content {
  padding-top: 30px;
  padding-left: 50px;
  padding-right: 50px;
  position: absolute;
  top: 50px;
  left: 0;
  right: 0;
  bottom: 0;
  overflow-y: scroll;
  overflow-x: hidden;
  min-height: 0;
}
.keypoints {
  border-left-style: solid;
  border-left-width: 5px;
  border-left-color: #b8da66;
  margin-left: 2rem;
}
.keypoints h3 {
  text-transform: uppercase;
  text-align: left;
  font-size: 1rem;
  font-family: Arial, Helvetica, sans-serif;
  font-weight: bold;
  color: #333;
  margin-left: 1rem;
  margin-bottom: 1rem;
}
.keypoints ul {
  margin-left: 1.5rem;
}
.keypoints li {
  display: list-item;
  list-style-type: disc;
  margin-bottom: 0.8rem;
}
img {
  float: right;
  margin-top: 50px;
}
button {
  background-color: #0071bc;
  border-radius: 3px;
  border: 0;
  color: #fff;
  font-size: 1rem;
  padding: 0.25rem 0.5rem;
  margin-top: 2rem;
  cursor: pointer;
  margin-left: 1rem;
}
.parent-sector {
  position: static;
  color: #6e5d11;
  z-index: 1;
  font-weight: bold;
  font-size: 1.2rem;
  padding-top: 10px;
  margin-left: 50px;
}
.center button {
  position: static !important;
}
</style>
